<template>
  <v-container>
    <v-layout>
      <v-flex>
        <v-toolbar color="white" dark flat dense cad>
          <v-toolbar-title class="indigo--text"
            >Reporte Detalles&nbsp;
            <v-tooltip bottom>
              <span slot="activator"
                ><v-icon dark color="grey" x-small>help</v-icon></span
              >
              <span
                >Debe seleccionar de manera obligatoria un nivel y un tipo de
                prueba.</span
              >
            </v-tooltip>
          </v-toolbar-title>
        </v-toolbar>
      </v-flex>
    </v-layout>
    <v-container grid-list-xl fluid>
      <v-layout justify-center>
        <v-flex xs12 md4>
          <v-select
            v-model="nivelValue"
            :items="nivelSelect"
            item-text="nombre"
            item-value="codigo"
            label="Nivel"
          ></v-select>
        </v-flex>
        <v-flex xs12 md4>
          <v-select
            v-model="tipoPruebaValue"
            :items="tipoPruebaSelect"
            label="Tipo Prueba"
            item-text="nombre"
            item-value="codigo"
          ></v-select>
        </v-flex>
        <v-btn
          fab
          dark
          color="teal"
          title="Filtrar detalle"
          @click="loadData()"
        >
          <v-icon dark>filter_list</v-icon>
        </v-btn>
        <!--<v-btn v-if="1==2" fab dark color="red darken-4" title="Limpiar filtros" @click="clear()">-->
        <v-btn
          fab
          dark
          color="red darken-4"
          title="Limpiar filtros"
          @click="clear()"
        >
          <v-icon dark>clear_all</v-icon>
        </v-btn>
      </v-layout>
      <v-layout>
        <v-flex lg12>
          <div v-if="loading">
            <loading></loading>
          </div>
          <div v-if="alerta">
            <alert-empty></alert-empty>
          </div>
          <v-spacer></v-spacer>
          <v-data-table
            :headers="headers"
            :items="items"
            class="elevation-1"
            :pagination.sync="miPaginacion"
            hide-actions
          >
            <template v-slot:items="props">
              <td class="text-xs-left">{{ props.item.nivel }}</td>
              <td class="text-xs-left">{{ props.item.tipoPrueba }}</td>
              <td class="text-xs-left">{{ props.item.idRegion }}</td>
              <td class="text-xs-left">{{ props.item.region }}</td>
              <td class="text-xs-left">{{ props.item.codigoCurso }}</td>
              <td class="text-xs-left">{{ props.item.codBarraContenedora }}</td>
              <td class="text-xs-left">{{ props.item.itemContrato }}</td>
              <td class="text-xs-left">{{ props.item.recibidos }}</td>
              <td class="text-xs-left">{{ props.item.fechaRecepcion }}</td>
            </template>
          </v-data-table>
          <!-- PAGINACION -->
          <v-flex xs12 sm6>
            <v-text-field
              value=""
              label="Total de Registros"
              v-model="miPaginacion.totalItems"
              disabled
            ></v-text-field>
          </v-flex>
          <div class="pt-2">
            <v-pagination
              v-model="miPaginacion.page"
              :length="numPaginas"
              :total-visible="7"
              circle
            ></v-pagination>
          </div>
        </v-flex>
      </v-layout>
      <!-- descarga informe -->
      <v-dialog v-model="loadingInforme" persistent max-width="390">
        <loading-descarga></loading-descarga>
      </v-dialog>
      <v-card-actions class="pb-3">
        <v-spacer></v-spacer>
        <v-btn
          :loading="loading"
          v-if="botonDescarga == true"
          color="primary"
          @click="descargaInforme()"
        >
          Descarga informe
          <v-icon right dark>folder</v-icon>
        </v-btn>
        <v-spacer></v-spacer>
      </v-card-actions>
    </v-container>
  </v-container>
</template>

<script>
import axios from "axios";
import Loading from "@/views/ui/Loading.vue";
import LoadingDescarga from "@/views/ui/Loading.vue";
import AlertEmpty from "@/views/ui/AlertEmpty.vue";
export default {
  name: "recepcionCap-reporteDetalles",

  components: {
    Loading,
    LoadingDescarga,
    AlertEmpty,
  },
  props: {},
  data() {
    return {
      idContrato: "",
      miPaginacion: {
        rowsPerPage: 20,
        page: 0,
      },
      items: [],
      loading: false,
      alerta: false,
      botonDescarga: false,
      loadingInforme: "",

      nivelValue: -1,
      nivelSelect: [],
      tipoPruebaValue: "",
      tipoPruebaSelect: [],
      headers: [
        { text: "Nivel", align: "left", sortable: false, value: "nivel" },
        {
          text: "Tipo Prueba",
          align: "left",
          sortable: false,
          value: "tipoPrueba",
        },
        { text: "Id Region", sortable: false, value: "idRegion" },
        { text: "Región", align: "left", sortable: false, value: "region" },
        { text: "Código Curso", sortable: false, value: "codigoCurso" },
        {
          text: "Código Barra Contenedora",
          align: "left",
          sortable: false,
          value: "codBarraContenedora",
        },
        { text: "Item", align: "left", sortable: false, value: "itemContrato" },
        { text: "Recepcionado", sortable: false, value: "recibidos" },
        {
          text: "Fecha Recepción",
          align: "left",
          sortable: false,
          value: "fechaRecepcion",
        },
      ],
    };
  },

  computed: {
    numPaginas() {
      if (
        this.miPaginacion.rowsPerPage == null ||
        this.miPaginacion.totalItems == null
      ) {
        return 0;
      }

      return Math.ceil(
        this.miPaginacion.totalItems / this.miPaginacion.rowsPerPage
      );
    },
  },

  created() {
    this.idContrato = this.$store.getters.contratoStored;

    this.loadNiveles();
    //datos en tabla [MATRIZ_RPT_RECEPCION] no corresponden a tabla [TIPO_PRUEBA], extrae lista distinct
    // this.loadTipoPrueba();
    //no busca nada hasta no especificar un nivel primero
    //this.loadData();
  },
  watch: {
    nivelValue(val) {
      if (val > 0) {
        this.loadTipoPrueba();
      }
    },
  },
  methods: {
    async loadData() {
      this.loading = true;
      this.items = [];
      this.miPaginacion.totalItems = 0;

      this.items = await this.loadReporteDetalles();

      this.miPaginacion.totalItems = this.items.length;
      if (this.items.length > 0) {
        this.alerta = false;
        this.botonDescarga = true;
      } else {
        this.alerta = true;
      }
      this.loading = false;
    },
    async loadReporteDetalles() {
      //sin nivel no busca nada

      //alert(this.idContrato + " - " + this.nivelValue);
      if (this.nivelValue <= 0) return [];

      let url =
        "/capturaRecepcion/reporteDetalle/" +
        this.idContrato +
        "/" +
        this.nivelValue;
      if (this.tipoPruebaValue != "") {
        url =
          "/capturaRecepcion/reporteDetallePrueba/" +
          this.idContrato +
          "/" +
          this.nivelValue +
          "/" +
          this.tipoPruebaValue;
      }
      //console.log("url::" + url);
      return await axios
        .get(url)
        .then(function (response) {
          return response.data;
        })
        .catch((error) => {
          if (error) {
            console.log(error.response.data);
            window.getApp.$emit("ERROR_EXCEPTION", error.response.data.message);
          }
          return [];
        });
    },
    async descargaInforme() {
      this.loadingDescarga = true;

      let url =
        "/capturaRecepcion/descargaReporteDetalle/" +
        this.idContrato +
        "/" +
        this.nivelValue;
      if (this.tipoPruebaValue != "") {
        url =
          "/capturaRecepcion/descargaReporteDetallePrueba/" +
          this.idContrato +
          "/" +
          this.nivelValue +
          "/" +
          this.tipoPruebaValue;
      }
      //console.log("url::" + url);
      return await axios
        .get(url, {
          responseType: "blob",
        })
        .then(function (response) {
          const urle = window.URL.createObjectURL(response.data);
          const link = document.createElement("a");
          link.href = urle;

          link.setAttribute("download", "Reporte_detalle.xlsx");
          document.body.appendChild(link);
          link.click();
          return response.data;
        })
        .catch(function (error) {
          if (error) {
            window.getApp.$emit(
              "ERROR_EXCEPTION",
              "Ha ocurrido un error al generar la descarga"
            );
          }
        });
    },
    async loadNiveles() {
      axios
        .get("/capturaRecepcion/getAllNiveles/" + this.idContrato)
        .then((response) => {
          let niveles = [];
          response.data.forEach(function (e) {
            niveles.push({
              nombre: e.descripcion,
              codigo: e.codNivelAce,
            });
          });
          this.nivelValue = -1;
          this.nivelSelect = niveles;
        })
        .catch(function (error) {
          window.getApp.$emit("ERROR_EXCEPTION_BACK");
          return;
        });
    },
    async loadTipoPrueba() {
      axios
        .get(
          "/capturaRecepcion/getAllTipoPrueba/" +
            this.idContrato +
            "/" +
            this.nivelValue
        )
        .then((response) => {
          let tipos = [];
          tipos.push({
            nombre: "",
            codigo: "",
          });
          response.data.forEach(function (e) {
            tipos.push({
              nombre: e,
              codigo: e,
            });
            //console.log("e:" + e);
          });
          this.tipoPruebaValue = "";
          this.tipoPruebaSelect = tipos;
        })
        .catch(function (error) {
          window.getApp.$emit("ERROR_EXCEPTION_BACK");
          return;
        });
    },

    clear() {
      this.nivelValue = null;
      this.tipoPruebaValue = null;
      this.items = [];
      this.miPaginacion.totalItems = 0;
    },
  },
};
</script>
